import React from "react";

const MenuChucNang = ({RoleThemMoiCuaHang, btnThemMoiCuaHangClick}) => (
    <div className="search-new" >
        <div className="input-sm-new" style={{width:"12%",display: RoleThemMoiCuaHang ? "block" : "none",}}>
            <button className="btn btn-sm" onClick={btnThemMoiCuaHangClick} style={{minWidth:"100%",color:"#00B69B",border:"2px solid #00B69B",backgroundColor:"white"}}><img src="/app-assets/images/icon-them-moi-cam-do.png" class="icon-button-v2"/><span style={{color:""}}>Thêm mới</span></button>
        </div>
    </div>
);

export default MenuChucNang;